var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99199 1.66675C5.39199 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.39199 18.3334 9.99199 18.3334C14.6003 18.3334 18.3337 14.6001 18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 9.99199 1.66675ZM10.0003 16.6667C6.31699 16.6667 3.33366 13.6834 3.33366 10.0001C3.33366 6.31675 6.31699 3.33341 10.0003 3.33341C13.6837 3.33341 16.667 6.31675 16.667 10.0001C16.667 13.6834 13.6837 16.6667 10.0003 16.6667Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 5.83325H9.16699V10.8333L13.542 13.4583L14.167 12.4333L10.417 10.2083V5.83325Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.95b5b1b7.svg";
export { ForwardRef as ReactComponent };